import React from 'react';
export function WhatIDo() {
  return <section className="py-20 md:py-24 px-6 md:px-12 bg-mist" data-id="element-162">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center" data-id="element-163">
        <div data-id="element-164">
          <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-165">
            I help new grads build a real path forward
            <span className="text-accent" data-id="element-166">.</span>
          </h2>
          <div className="space-y-6 text-lg text-ink/80 leading-relaxed" data-id="element-167">
            <p data-id="element-168">
              I work 1:1 with new grads to help them get clear on their
              strengths, explore career directions, build confidence, and take
              practical steps toward work that fits.
            </p>
            <p className="font-medium text-teal" data-id="element-169">
              This is part coaching, part mentoring, part real-world career
              navigation.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-170">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-teal/5" data-id="element-171">
            <div className="w-10 h-10 bg-clay rounded-full mb-4 flex items-center justify-center text-teal font-serif text-xl" data-id="element-172">
              1
            </div>
            <h3 className="font-serif text-xl mb-2" data-id="element-173">Clarity</h3>
            <p className="text-sm text-ink/70" data-id="element-174">
              Get clear on strengths and explore directions.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-teal/5 translate-y-8" data-id="element-175">
            <div className="w-10 h-10 bg-clay rounded-full mb-4 flex items-center justify-center text-teal font-serif text-xl" data-id="element-176">
              2
            </div>
            <h3 className="font-serif text-xl mb-2" data-id="element-177">Confidence</h3>
            <p className="text-sm text-ink/70" data-id="element-178">
              Build confidence to talk about yourself.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-teal/5" data-id="element-179">
            <div className="w-10 h-10 bg-clay rounded-full mb-4 flex items-center justify-center text-teal font-serif text-xl" data-id="element-180">
              3
            </div>
            <h3 className="font-serif text-xl mb-2" data-id="element-181">Strategy</h3>
            <p className="text-sm text-ink/70" data-id="element-182">
              Take practical steps toward work that fits.
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border border-teal/5 translate-y-8" data-id="element-183">
            <div className="w-10 h-10 bg-clay rounded-full mb-4 flex items-center justify-center text-teal font-serif text-xl" data-id="element-184">
              4
            </div>
            <h3 className="font-serif text-xl mb-2" data-id="element-185">Support</h3>
            <p className="text-sm text-ink/70" data-id="element-186">
              Real-world career navigation and mentoring.
            </p>
          </div>
        </div>
      </div>
    </section>;
}